import script from "./ViewMoreWork.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewMoreWork.vue?vue&type=script&setup=true&lang=js"

import "./ViewMoreWork.vue?vue&type=style&index=0&id=11f24350&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11f24350"]])

export default __exports__